export type AcomoInfo = {
  version: string
}

// TODO: バックエンドから取得する
export const acomoInfo: AcomoInfo = {
  version: '1.0.0'
}

// TODO: OpenAPIでクライアントや型は自動生成したい

// jwt.strategy.tsのProfile
export type UserProfile = {
  id: string,
  email: string,
  name: string,
}
